export default __webpack_public_path__ + "static/media/marca-x.5f9cacdf.svg";